var _path, _rect, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m51 41v2h-42v-2c-1.105 0-2-.895-2-2v-29c0-1.657 1.343-3 3-3h40c1.657 0 3 1.343 3 3v29c0 1.105-.895 2-2 2z",
    fill: "#204272"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#35a5f9",
    height: 38,
    rx: 1,
    transform: "matrix(0 1 -1 0 54 -6)",
    width: 26,
    x: 17,
    y: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.83 49c-.1-.29-.25-.55-.43-.8l-4.5-6c-.57-.76-1.46-1.2-2.4-1.2h-43c-.94 0-1.83.44-2.4 1.2l-4.5 6c-.18.25-.33.51-.43.8-.11.32-.17.66-.17 1v1c0 1.1.9 2 2 2h54c1.1 0 2-.9 2-2v-1c0-.34-.06-.68-.17-1z",
    fill: "#d3e3f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m59 50v1c0 1.1-.9 2-2 2h-54c-1.1 0-2-.9-2-2v-1c0-.34.06-.68.17-1h57.66c.11.32.17.66.17 1z",
    fill: "#a7c2d3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m38 49-1.681-3.362c-.196-.391-.595-.638-1.032-.638h-10.573c-.437 0-.837.247-1.032.638l-1.681 3.362h16z",
    fill: "#bad0e2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#50bcff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.19 11-13.413 26h-10.323l13.413-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.546 11-13.413 26h-6.194l13.413-26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.d1e8c5ceca2077a84ccb962954b3f22c.svg";
export { ForwardRef as ReactComponent };